"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var KsysRequest_1 = require("../KsysRequest");
var Execute = /** @class */ (function (_super) {
    __extends(Execute, _super);
    function Execute() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getExplicitEndpoint = function () { return '/dataset/execute'; };
        return _this;
    }
    Object.defineProperty(Execute.prototype, "endpointConfiguration", {
        get: function () {
            return this.getEndpointConfiguration("dataset", "Execute");
        },
        enumerable: true,
        configurable: true
    });
    return Execute;
}(KsysRequest_1.KsysRequest));
exports.Execute = Execute;
var ExecuteGet = /** @class */ (function (_super) {
    __extends(ExecuteGet, _super);
    function ExecuteGet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getExplicitEndpoint = function () { return '/dataset/execute'; };
        _this.getExplicitMethod = function () { return 'GET'; };
        return _this;
    }
    Object.defineProperty(ExecuteGet.prototype, "endpointConfiguration", {
        get: function () {
            return this.getEndpointConfiguration("dataset", "Execute");
        },
        enumerable: true,
        configurable: true
    });
    return ExecuteGet;
}(KsysRequest_1.KsysRequest));
exports.ExecuteGet = ExecuteGet;
//# sourceMappingURL=Execute.js.map